import Form from "@/Form";
import Modal from "@/Modal";

import "./style.css";

export default class RequestCopyModal extends Modal {
  static selector = ".request-copy-modal";

  modalDidMount = async () => {
    this.formElement = this.modal.querySelector(".request-copy-modal__form");
    this.form = new Form(this.formElement, {
      onSubmitSucceeded: this.handleFormSubmitSucceeded,
      onSubmitFailed: this.handleSubmitFailed,
      resetAfterSubmit: true,
      gainControlOnSubmitSucceeded: false
    });

    this.publicationField = this.modal.querySelector(
      'input[name="publication"]'
    );
  };
  modalWillOpen = async () => {
    this.form.reset();
    this.modal.classList.remove("request-copy-modal--success");
  };
  modalDidUpdate = async ({ publicationId = "" }) => {
    this.publicationField.value = publicationId;
  };

  handleFormSubmitSucceeded = () => {
    this.modal.classList.add("request-copy-modal--success");
  };
}
